import { ICreateReajusteUseCase } from "../../../presentation/useCases/create/create_reajuste_use_case";
import { Reajuste } from "../../models/reajuste";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * CreateReajusteUseCase
 */

export class CreateReajusteUseCase implements ICreateReajusteUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async createReajuste(form: Reajuste): Promise<void> {
    await this.repository.createReajuste(form);

  }
}
